// Logger levels: error, warn, info, debug
const LOG_LEVELS = {
  ERROR: 'error',
  WARN: 'warn',
  INFO: 'info',
  DEBUG: 'debug'
};

// Default to 'error' in production, 'debug' in development
const DEFAULT_LEVEL = LOG_LEVELS.ERROR;

class Logger {
  constructor() {
    this.level = DEFAULT_LEVEL;
  }

  setLevel(level) {
    if (LOG_LEVELS[level.toUpperCase()]) {
      this.level = level.toLowerCase();
    }
  }

  shouldLog(level) {
    const levels = Object.values(LOG_LEVELS);
    return levels.indexOf(level) <= levels.indexOf(this.level);
  }

  _formatMessage(message, ...args) {
    const timestamp = new Date().toISOString();
    return `[${timestamp}] ${message}`;
  }

  error(message, ...args) {
    if (this.shouldLog(LOG_LEVELS.ERROR)) {
      console.error(this._formatMessage(message), ...args);
    }
  }

  warn(message, ...args) {
    if (this.shouldLog(LOG_LEVELS.WARN)) {
      console.warn(this._formatMessage(message), ...args);
    }
  }

  info(message, ...args) {
    if (this.shouldLog(LOG_LEVELS.INFO)) {
      console.info(this._formatMessage(message), ...args);
    }
  }

  debug(message, ...args) {
    if (this.shouldLog(LOG_LEVELS.DEBUG)) {
      console.debug(this._formatMessage(message), ...args);
    }
  }

  group(label) {
    if (this.shouldLog(LOG_LEVELS.DEBUG)) {
      console.group(this._formatMessage(label));
    }
  }

  groupEnd() {
    if (this.shouldLog(LOG_LEVELS.DEBUG)) {
      console.groupEnd();
    }
  }
}

const logger = new Logger();

// Prevent creation of new logger instances
Object.freeze(logger);

export default logger; 